import * as S from './RouterLink.styles';

export default S.RouterLink;
